<template>
  <BaseDialog centered contentClass="edit-opportunity-label" ref="dialog" :show-actions="true">
    <template slot="title">{{ $t('page.admin-opportunity-labels.edit-dialog.title') }}</template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div>
          <FormInput
            ref="labelNameValue"
            :label="$t('page.admin-opportunity-labels.edit-dialog.name')"
            is-required
            has-gray-background
            name="name"
            type="name"
            v-model="labelName"
            v-validate="'required'"
          />
          <FormInput
            :label="$t('page.admin-opportunity-labels.edit-dialog.description')"
            is-required
            has-gray-background
            name="description"
            v-model="labelDescription"
            v-validate="'required'"
          />
          <FormColorPicker
            :label="$t('page.admin-opportunity-labels.edit-dialog.color')"
            v-model="labelColor"
            is-required
          />
        </div>
        <div class="edit-opportunity-label__actions">
          <FormButton is-outlined class="edit-opportunity-label__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit" :disabled="isFormInvalid || !hasChanged">
            <span>{{ $t('actions.save') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';
import { mapActions } from 'vuex';
import FormColorPicker from '@/components/form/FormColorPicker.vue';

export default {
  name: 'EditOpportunityLabelDialog',
  components: {
    FormColorPicker,
    BaseDialog,
    FormButton,
    FormInput,
  },
  data() {
    return {
      labelName: '',
      labelDescription: '',
      labelColor: '',
      opportunityLabel: null,
    };
  },
  computed: {
    isFormInvalid() {
      return !this.labelName || !this.labelDescription || !this.labelColor;
    },
    hasChanged() {
      return (
        this.labelName !== this.opportunityLabel.name ||
        this.labelDescription !== this.opportunityLabel.description ||
        this.labelColor !== this.opportunityLabel.color
      );
    },
  },
  methods: {
    ...mapActions('opportunityLabels', ['editOpportunityLabel']),
    openDialog(opportunityLabel) {
      this.opportunityLabel = opportunityLabel;
      this.labelName = opportunityLabel.name;
      this.labelDescription = opportunityLabel.description;
      this.labelColor = opportunityLabel.color;
      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        const refInput = this.$refs.labelNameValue.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      const opportunityLabel = {
        name: this.labelName,
        description: this.labelDescription,
        color: this.labelColor,
      };
      this.editOpportunityLabel({ opportunityLabelId: this.opportunityLabel.id, opportunityLabel })
        .then(() => {
          this.$toast.success(this.$t('page.admin-opportunity-labels.edit-dialog.edit-opportunity-label-success'));
          this.$emit('action-succeeded');
        })
        .catch((error) => this.$toast.error(error));
      this.closeDialog();
    },
    handleKeyup(event) {
      const keyCode = event.keyCode || event.charCode;

      if (keyCode === 13) {
        if (!this.isFormInvalid) this.onSubmit();
        return;
      }
    },
    cancelClick() {
      this.closeDialog();
    },
  },
  created() {
    document.addEventListener('keyup', this.handleKeyup);
  },
  destroyed() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
};
</script>

<style lang="scss">
.base-dialog__edit-opportunity-label {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.edit-opportunity-label {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }
}
</style>
